module.exports = __webpack_public_path__ + "img/step3.e6ef1ffb.jpg";